import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
// import getPageLocalesData from '@src/global-locales/get-page-locales-data';
// import { useEffect } from 'react';

// const pageLocalesData = getPageLocalesData();
// const mechasMsg = pageLocalesData.mechasMsg;


class MechaMoreStore {
  @observable isActive = false;

  // 当前机甲列表
  @observable currentMechaId = '';
  // 机甲列表轮播图
  mechaListSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 'auto',
      autoplay: false,
      allowTouchMove: false,
    }
  });
  // 机甲主store
  @observable mechaStore;

    // 机甲列表
  @observable mechaListData;

  constructor(options = {}) {
    Object.assign(this, options);
  }

  @computed
  get mechaBtnList() {

    const mechaListArr = [];
    this.mechaStore?.mechaList?.forEach(item => {
      if (item.mecha_id !== this.currentMechaId) {
        mechaListArr.push({
          id: item.mecha_id,
          name: item.cn_name,
          btn_image: item.mecha_tab_icon,
          btn_hover_image: item.mecha_tab_icon_hov
        });
      }
    });
    return mechaListArr;
  }

  onClickGoPrev = () => {
    this.mechaListSwiper.goPrev();
    // this.mechaStore.onClickChangeMecha(this.mechaBtnList[this.mechaListSwiper.activeIndex].id)

  };
  onClickGoNext = () => {
    this.mechaListSwiper.goNext();
    // this.mechaStore.onClickChangeMecha(this.mechaBtnList[this.mechaListSwiper.activeIndex].id)
  };

  use() {
    useMount(() => {});
  }
}

export default MechaMoreStore;
